<div class="vzc-verify-account">
  <h1 class="vzc-verify-account__heading" i18n="@@S_ACCOUNT_ACTIVATION_VERIFY_ACCOUNT_HEADING">Verify your account</h1>

  <p class="vzc-verify-account__subheading" i18n="@@S_ACCOUNT_ACTIVATION_VERIFY_ACCOUNT_SUBHEADING">
    Enter the verification code we sent to <b>{{ username$ | async }}</b>
  </p>

  <form [formGroup]="form" class="vzc-verify-account__form" autocomplete="off">
    <app-verification-code [verificationCode]="verificationCode"></app-verification-code>

    <app-spinner-button
      i18n-label="@@S_CAP_ACCOUNT_ACTIVATION_VERIFY_ACCOUNT"
      label="VERIFY ACCOUNT"
      [isDisabled]="
        form.invalid ||
        (isTooManyVerificationAttempts$ | async) ||
        (isMaxAttempts$ | async) ||
        (verifyAccountRequestStatus$ | async) === apiRequestStatus.Request
      "
      [isSpinning]="(verifyAccountRequestStatus$ | async) === apiRequestStatus.Request"
      (clickFunction)="completeRequest()"
    ></app-spinner-button>
  </form>

  <p class="vzc-verify-account__info" i18n="@@S_ACCOUNT_ACTIVATION_VERIFY_ACCOUNT_DONT_SEE_EMAIL">
    If you don't see the email, check your spam folder or resend the verification code.
  </p>

  <app-spinner-button
    i18n-label="@@S_CAP_ACCOUNT_ACTIVATION_RESEND_CODE"
    label="RESEND CODE"
    [color]="undefined"
    [isDisabled]="
      (isTooManyResendAttempts$ | async) ||
      (isTooManyVerificationAttempts$ | async) ||
      (resendCodeRequestStatus$ | async) === apiRequestStatus.Request
    "
    [isSpinning]="(resendCodeRequestStatus$ | async) === apiRequestStatus.Request"
    (clickFunction)="resendCode()"
  ></app-spinner-button>

  <app-warning-banner
    *ngIf="(isTooManyVerificationAttempts$ | async) || (isRequestFailure$ | async)"
    i18n-errorMessage="@@E_ACCOUNT_ACTIVATION_VERIFY_ACCOUNT_ERROR_MESSAGE"
    errorMessage="We could not verify your account. Please try again."
  ></app-warning-banner>

  <app-success-banner
    *ngIf="(resendCodeRequestStatus$ | async) === apiRequestStatus.Success"
    i18n-successMessage="@@S_ACCOUNT_ACTIVATION_CODE_RESENT_MESSAGE"
    successMessage="Successfully re-sent the code."
  ></app-success-banner>
</div>
